import { css } from '@emotion/react'
import { Flow, Heading, Icon, Text } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { TipoDocumentoCidadaoEnum } from 'graphql/types.generated'
import {
  MSG_INFO_DOCUMENTOS_ASSOCIADOS,
  MSG_SALVAR_ALTERACOES_DOCUMENTOS_ASSOCIADOS,
} from 'view/cidadao/constants-cidadao'

interface DocumentoAssociado {
  documento: string
  tipoDocumento: TipoDocumentoCidadaoEnum
  stRemovido?: boolean
}

interface CidadaoDocumentosAssociadosProps {
  documentosAssociados: DocumentoAssociado[]
}

export const CidadaoDocumentosAssociados = ({ documentosAssociados }: CidadaoDocumentosAssociadosProps) => {
  const styles = createStyles()
  const hasDocumentoRemovido = documentosAssociados.some((documento) => documento.stRemovido)

  return (
    <Flow direction='vertical' gap={0.5}>
      <Flow direction='horizontal' alignItems='center' gap={0.5}>
        <Heading level={4}>Outros documentos associados ao cadastro individual</Heading>
        <InfoIcon icon='infoCircleFilled' text={MSG_INFO_DOCUMENTOS_ASSOCIADOS} />
      </Flow>
      <Text style={styles.lista}>
        {documentosAssociados.map((documento) => (
          <span key={documento.documento} css={documento.stRemovido && styles.documentoRemovido}>
            <Text fontWeight='bold'>{documento.tipoDocumento}</Text> {documento.documento + ' '}
          </span>
        ))}
      </Text>
      {hasDocumentoRemovido && (
        <Flow direction='horizontal' alignItems='center' gap={0.25}>
          <Icon icon='clockOutline' fill='danger' size={1} />
          <Text color='danger'>{MSG_SALVAR_ALTERACOES_DOCUMENTOS_ASSOCIADOS}</Text>
        </Flow>
      )}
    </Flow>
  )
}

const createStyles = () => ({
  lista: css`
    & > span + span::before {
      content: '| ';
      white-space: pre;
      /* inline-block impede que o risco do documento removido se estenda ao separador */
      display: inline-block;
    }
  `,
  documentoRemovido: css`
    text-decoration: line-through;
  `,
})
